import Vue from 'vue';

import {
  ActionSheet,
  AddressEdit,
  AddressList,
  Area,
  Button,
  Calendar,
  Card,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Circle,
  Col,
  Collapse,
  CollapseItem,
  ContactCard,
  ContactEdit,
  ContactList,
  Coupon,
  CouponCell,
  CouponList,
  DatetimePicker,
  Dialog,
  Empty,
  Field,
  Form,
  Grid,
  GridItem,
  Icon,
  Image,
  ImagePreview,
  IndexBar,
  IndexAnchor,
  Lazyload,
  List,
  Loading,
  Locale,
  NavBar,
  NoticeBar,
  Notify,
  NumberKeyboard,
  Overlay,
  Pagination,
  PasswordInput,
  Picker,
  Popup,
  Progress,
  PullRefresh,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Search,
  Slider,
  Step,
  Stepper,
  Steps,
  Sticky,
  SubmitBar,
  Swipe,
  SwipeCell,
  SwipeItem,
  Switch,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast,
  TreeSelect,
  Uploader
} from 'vant'

Vue.use(ActionSheet)
  .use(AddressEdit)
  .use(AddressList)
  .use(Area)
  .use(Button)
  .use(Calendar)
  .use(Card)
  .use(Cell)
  .use(CellGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Circle)
  .use(Col)
  .use(Collapse)
  .use(CollapseItem)
  .use(ContactCard)
  .use(ContactEdit)
  .use(ContactList)
  .use(Coupon)
  .use(CouponCell)
  .use(CouponList)
  .use(DatetimePicker)
  .use(Dialog)
  .use(Empty)
  .use(Field)
  .use(Form)
  .use(Grid)
  .use(GridItem)
  .use(Icon)
  .use(Image)
  .use(ImagePreview)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Lazyload)
  .use(List)
  .use(Loading)
  .use(Locale)
  .use(NavBar)
  .use(NoticeBar)
  .use(Notify)
  .use(NumberKeyboard)
  .use(Overlay)
  .use(Pagination)
  .use(PasswordInput)
  .use(Picker)
  .use(Popup)
  .use(Progress)
  .use(PullRefresh)
  .use(Radio)
  .use(RadioGroup)
  .use(Rate)
  .use(Row)
  .use(Search)
  .use(Slider)
  .use(Step)
  .use(Stepper)
  .use(Steps)
  .use(Sticky)
  .use(SubmitBar)
  .use(Swipe)
  .use(SwipeCell)
  .use(SwipeItem)
  .use(Switch)
  .use(Tab)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Tabs)
  .use(Tag)
  .use(Toast)
  .use(TreeSelect)
  .use(Uploader)
